import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useQueryParams } from '../../../utils/useQueryParams';
import React, { useEffect } from 'react';
import { showResourceModal } from '../../../actions/modalActions';
import PermissionDenied from '../../scheduler/components/permissionDenied/permissionDenied';
import authorization from '../../../services/auth/authorization';
import { resourceActions } from '@hub-mono/app-modules';
import { TYPE_UNASSIGNED } from '../../../enums/resourceEnum';
import { useIsExtensionInstalled } from '../../../hooks';
import { UNASSIGNED } from '../../../enums/extensionShortIdEnum';

const NewUnassignedModalRoute = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const queryParams = useQueryParams();
    const isSmartSchedulesInstalled = useIsExtensionInstalled(UNASSIGNED);

    useEffect(() => {
        const redirectFallback = () => {
            if (queryParams.fallbackUrl) {
                window.location.href = queryParams.fallbackUrl;
            } else {
                window.location.href = '/';
            }
        };

        if (!isSmartSchedulesInstalled) {
            redirectFallback();
        }

        dispatch(
            showResourceModal({
                onSubmit: data => dispatch(resourceActions.create.request(data, undefined, true)),
                type: TYPE_UNASSIGNED.value,
                onClose: () => {
                    redirectFallback();
                },
            })
        );
    }, [dispatch, isSmartSchedulesInstalled, params.resourceId, params.type, queryParams.fallbackUrl, queryParams.successUrl]);

    return <></>;
};

const authParameters = {
    allowedRoleRights: ['settingAddEditResources'],
    redirectOnLackOfRights: true,
    errorComponent: PermissionDenied,
};

export const NewUnassignedModalRouteAuth = authorization(authParameters)(NewUnassignedModalRoute);
